<!-- Contenedor Documentos por Vehículo -->
  <div>
    @if (hasActiveVehicles()) {
      <div class="">
        <div class="tab-pane fade show active" id="general">
             @if (getActiveVehiclesCount() > 1) {
               <div class="btn-group mb-3">
                  @for(v of vehicles(); track v.uuid) {
                    @if (isVehicleValid(v)) {
                      <button class="btn btn-primary btn-sm" 
                          [class.active]="selectedVehicleUuid() === v.uuid"
                          (click)="selectVehicle(v.uuid)">
                         <i class="fas fa-car me-2"></i>{{ v.plate }} - {{ v.brandName }} 
                     </button>
                   }
                 }
               </div>
             }
    
          @if (getFilteredVehicleDocs().length > 0) {
            <div class="table-responsive table-data">
              <table class="table table-sm table-hover align-middle">
                <thead>
                  <tr>
                    <th style="width: 30%;">Documento Requerido</th>
                    <th style="width: 25%;">Archivo</th>
                    <th style="width: 15%;" class="text-center">Estado</th>
                    <th style="width: 15%;" class="text-center">Vencimiento</th>
                    <th style="width: 15%;" class="text-end"><i class="fas fa-cog me-1"></i></th>
                  </tr>
                </thead>
                <tbody>
                  @for(cat of getFilteredVehicleDocs(); track cat.categorySlug) {
                    @for(d of cat.documents; track d.uuid) {
                      <tr style="height: 42px;">
                        <td class="fw-semibold text-dark">{{ d.docTypeName }}</td>
                        <td>
                          @if(d.filePath) {
                            <a [href]="globalUrl + d.filePath" target="_blank" class="text-primary text-decoration-none">
                              <i class="far fa-file-alt me-1.5 text-info"></i>{{ d.fileName }}
                            </a>
                          } @else {
                            <span class="text-muted small italic"><i class="fas fa-exclamation-circle me-1 text-warning"></i>Pendiente de Carga</span>
                          }
                        </td>
                        <td class="text-center">
                          <span class="badge border py-1 px-2.5 rounded-pill" 
                             [ngClass]="d.statusStyle || 'bg-light text-secondary border-secondary'" 
                             style="font-size: 10px;">
                            {{ d.statusName || 'Pendiente' }}
                          </span>
                        </td>
                        <td class="text-center">
                          @if(d.expirationDate) {
                            <span class="badge py-1 px-2.5 rounded-pill"
                               [ngClass]="'bg-' + (d.expirationStyle || 'secondary')"
                               style="font-size: 10px;">
                              {{ d.expirationStatus }} ({{ d.expirationDate | date: 'dd/MM/yyyy' }})
                            </span>
                          } @else {
                            <span class="text-muted small">-</span>
                          }
                        </td>
                        <td class="text-end">
                          <div class="d-inline-flex gap-1">
                            <!-- Botón Ver (Ojo) -->
                            @if(d.filePath) {
                              <button type="button" class="btn btn-outline-primary btn-xs" 
                                 (click)="openViewer(d.uuid)"
                                 ngbTooltip="Visualizar Documento" placement="top">
                                <i class="fas fa-eye"></i>
                              </button>
                            }

                            <!-- Botón Subir / Editar -->
                            @if(mode() !== formMode.VIEW) {
                              <app-document-upload 
                                 [uuid]="d.uuid" 
                                 [origin]="'VEHICLE'" 
                                 (onSuccess)="onDocumentUpdate.emit()">
                              </app-document-upload>
                            }
                          </div>
                        </td>
                      </tr>
                    }
                  }
                </tbody>
              </table>
            </div>
          } @else {
            <div class="text-center text-muted py-5 bg-light rounded border border-dashed m-3">
              <i class="fas fa-folder-open fs-2 mb-3 text-secondary d-block"></i>
              <p class="m-0 fw-semibold text-dark">No hay requisitos documentales cargados</p>
              <p class="small text-muted m-0">No se encontraron requisitos documentales para este vehículo.</p>
            </div>
          }
        
        </div>
      </div>
    } @else {
      <div class="panel-body">
      <div class="text-center text-muted py-5 bg-light rounded border border-dashed m-3">
        <i class="fas fa-car-crash fs-2 mb-3 text-secondary d-block"></i>
        <p class="m-0 fw-semibold text-dark">No hay vehículos registrados</p>
        <p class="small text-muted m-0">Este socio no tiene ningún vehículo registrado para asignarle documentación.</p>
      </div>
      </div>
    }
  </div>

